import { ComponentProps, useState } from 'react';

import ItemShelf from '@/components/ItemShelf/ItemShelf';
import { ItemShelfCarousel } from '@/components/ItemShelfCarousel/ItemShelfCarousel';
import { RecommendationVisibilityWrapper } from '@/pages/Item/ItemPage/components/ItemPageCarousel/RecommendationVisibilityWrapper';
import { useAppSelector } from '@/redux/hooks';
import { getTrendingItems } from '@/redux/modules/home/home.selectors';
import { LotRecommendationType } from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
};

export const TrendingItemsCarousel = ({ className, shouldUseHomePageRedesign = false }: Props) => {
    const formatMessage = useAppFormatMessage();

    const itemIds = useAppSelector(getTrendingItems);
    const [visibleItemIds, setVisibleItemIds] = useState<number[]>([]);

    if (!itemIds.length) {
        return null;
    }

    const shelfProps: ComponentProps<typeof ItemShelf> = {
        className,
        identifier: 'trendingItems',
        itemIds,
        onVisibleItemIdsChange: setVisibleItemIds,
        testid: 'trendingItemsCarousel',
        title: String(formatMessage(['trending_items'])),
    };

    return (
        <RecommendationVisibilityWrapper
            recommendationIds={visibleItemIds}
            recommendationType={LotRecommendationType.TrendingItems}
        >
            {shouldUseHomePageRedesign ? <ItemShelfCarousel {...shelfProps} /> : <ItemShelf {...shelfProps} />}
        </RecommendationVisibilityWrapper>
    );
};
